export default __webpack_public_path__ + "static/media/salescontest.74a2dd4f.png";